import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import { RockPaperScissorsGameStatus } from '~/shared';

const StyledContainer = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(17, 19, 20, 0.5);
	transition: opacity 0.3s ease;
	opacity: 0;

	&.fade-enter {
		opacity: 0;
	}

	&.fade-enter-active,
	&.fade-enter-done,
	&.fade-exit {
		opacity: 1;
	}

	&.fade-exit-active {
		opacity: 0;
	}
`;

const StyledIcon = styled.div<{
	$type:
		| RockPaperScissorsGameStatus.WON
		| RockPaperScissorsGameStatus.LOST
		| RockPaperScissorsGameStatus.DRAW;
}>`
	position: absolute;
	width: 300px;
	height: 300px;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	background-color: ${({ $type }) =>
		$type === RockPaperScissorsGameStatus.WON
			? '#77DE38'
			: $type === RockPaperScissorsGameStatus.LOST
			? '#FF3E3E'
			: '#FFFFFF'};
	opacity: 0.1;
	mask-size: contain;
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-size: contain;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
`;

const StyledResultText = styled(Text)<{
	$type:
		| RockPaperScissorsGameStatus.WON
		| RockPaperScissorsGameStatus.LOST
		| RockPaperScissorsGameStatus.DRAW;
}>`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-weight: 700;
	font-size: 60px;
	color: ${({ $type }) =>
		$type === RockPaperScissorsGameStatus.WON
			? '#77DE38'
			: $type === RockPaperScissorsGameStatus.LOST
			? '#FF3E3E'
			: '#FFFFFF'};
`;

const StyledBottomText = styled(Text)`
	position: absolute;
	top: calc(50% + 45px);
	left: 50%;
	transform: translate(-50%, -50%);
	font-weight: 500;
	font-size: 18px;
	color: #ffffff;
`;

export { StyledBottomText, StyledContainer, StyledIcon, StyledResultText };
